export const OPTUM_FRONTIER_THERAPIES = "Optum Frontier Therapies";
export const PANTHERX = "PANTHERx Rare";
